/**
 * @generated SignedSource<<7e7cefd574484be8452570f1ad29dde3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WorkspaceRunnerPhase = "BINDING_VOLUME" | "PENDING" | "PREPARING_WORKSPACE" | "READY" | "SCHEDULING_POD" | "STARTING_POD";
import { FragmentRefs } from "relay-runtime";
export type WorkspacePhaseProgressFragment$data = {
  readonly phase: WorkspaceRunnerPhase;
  readonly " $fragmentType": "WorkspacePhaseProgressFragment";
};
export type WorkspacePhaseProgressFragment$key = {
  readonly " $data"?: WorkspacePhaseProgressFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspacePhaseProgressFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspacePhaseProgressFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phase",
      "storageKey": null
    }
  ],
  "type": "WorkspaceRunner",
  "abstractKey": null
};

(node as any).hash = "0c16ed8ef00e020bd8fc3ab480d178d1";

export default node;
